var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "7px",
    viewBox: "0 0 53 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.2 0.6 5.8 0.6 5.8 6.3999 0.2 6.3999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 8 52.9 8 52.9 0.6 0 0.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 0.10009 0 5.70009 3.8 5.70009 3.8 4.80009 1 4.80009 1 3.29909 3.7 3.29909 3.7 2.39909 1 2.39909 1 1.00009 3.8 1.00009 3.8 0.10009"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.000000, -0.600010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1001,3.3998 L6.1001,1.5998 L7.4001,1.5998 C8.0001,1.5998 8.4001,1.8998 8.4001,2.4998 C8.4001,3.0998 8.0001,3.3998 7.4001,3.3998 L6.1001,3.3998 Z M9.4001,2.4998 C9.4001,1.4998 8.7001,0.7998 7.6001,0.7998 L5.1001,0.7998 L5.1001,6.3998 L6.1001,6.3998 L6.1001,4.1998 L7.1001,4.1998 L8.3001,6.2998 L9.4001,6.2998 L8.1001,4.0998 C8.7001,3.9998 9.4001,3.4998 9.4001,2.4998 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7002,4.2001 L14.4002,4.2001 L14.4002,5.1001 C14.2002,5.3001 13.7002,5.6001 13.1002,5.6001 C12.0002,5.6001 11.2002,4.8001 11.2002,3.6001 C11.2002,2.4001 12.0002,1.6001 13.1002,1.6001 C13.7002,1.6001 14.2002,1.9001 14.5002,2.3001 L15.3002,1.9001 C14.8002,1.2001 14.1002,0.6001 13.0002,0.6001 C11.4002,0.6001 10.1002,1.7001 10.1002,3.5001 C10.1002,5.2001 11.4002,6.4001 13.0002,6.4001 C14.0002,6.4001 14.7002,6.0001 15.3002,5.4001 L15.3002,3.3001 L12.7002,3.3001 L12.7002,4.2001 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.4999 C1.9,5.4999 1.2,4.5999 1.2,3.4999 C1.2,2.3999 1.9,1.4999 3,1.4999 C4.1,1.4999 4.8,2.3999 4.8,3.4999 C4.8,4.6999 4.1,5.4999 3,5.4999 M3,0.5999 C1.3,0.5999 0.2,1.7999 0.2,3.4999 C0.2,5.1999 1.4,6.3999 3,6.3999 C4.6,6.3999 5.8,5.1999 5.8,3.4999 C5.8,1.7999 4.6,0.5999 3,0.5999",
    id: "Fill-6",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "24.6001 6.3998 28.1001 6.3998 28.1001 6.0008 25.1001 6.0008 25.1001 3.7998 28.0001 3.7998 28.0001 3.2998 25.1001 3.2998 25.1001 1.2998 28.1001 1.2998 28.1001 0.7998 24.6001 0.7998"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "32.2002 2.3998 31.7002 2.3998 30.5002 3.9998 29.2002 2.3998 28.7002 2.3998 30.2002 4.2998 28.5992 6.3998 29.0992 6.3998 30.5002 4.5998 31.8002 6.3998 32.3002 6.3998 30.7002 4.2998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7998,6.1 C34.1998,6.1 33.6998,5.8 33.4998,5.4 L33.4998,3.4 C33.6998,3 34.2998,2.7 34.7998,2.7 C35.6998,2.7 36.1998,3.4 36.1998,4.4 C36.1998,5.3 35.6998,6.1 34.7998,6.1 M34.9008,2.3 C34.2998,2.3 33.7998,2.6 33.4998,3 L33.4998,2.4 L33.0998,2.4 L33.0998,8 L33.4998,8 L33.4998,5.7 C33.7998,6.2 34.2998,6.4 34.9008,6.4 C35.9998,6.4 36.6998,5.6 36.6998,4.3 C36.6998,3.1 35.9998,2.3 34.9008,2.3",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    mask: "url(#mask-4)",
    points: "37.7 6.4 38.099 6.4 38.099 0.8 37.7 0.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0996,6.1 C40.2006,6.1 39.5996,5.3 39.5996,4.4 C39.5996,3.5 40.0996,2.7 41.0996,2.7 C41.9996,2.7 42.5996,3.5 42.5996,4.4 C42.4996,5.3 41.9996,6.1 41.0996,6.1 M41.0996,2.3 C39.9006,2.3 39.2006,3.2 39.2006,4.4 C39.2006,5.6 39.9996,6.5 41.0996,6.5 C42.2996,6.5 42.9996,5.6 42.9996,4.4 C42.9996,3.2 42.2006,2.3 41.0996,2.3",
    id: "Fill-17",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4004,3.1 L44.4004,2.4 L44.0004,2.4 L44.0004,6.4 L44.4004,6.4 L44.4004,3.5 C44.5994,3.2 45.0994,2.8 45.5004,2.8 L45.7004,2.8 L45.7004,2.3 C45.2004,2.3 44.7994,2.6 44.4004,3.1",
    id: "Fill-18",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7998,4.2001 C46.7998,3.5001 47.2998,2.7001 48.2998,2.7001 C49.2998,2.7001 49.7998,3.5001 49.7998,4.2001 L46.7998,4.2001 Z M48.2998,2.3001 C47.1998,2.3001 46.4008,3.2001 46.4008,4.4001 C46.4008,5.6001 47.1998,6.5001 48.4008,6.5001 C49.0998,6.5001 49.5998,6.3001 49.9998,5.9001 L49.6998,5.6001 C49.4008,6.0001 48.9008,6.2001 48.4008,6.2001 C47.4998,6.2001 46.9008,5.5001 46.7998,4.6001 L50.1998,4.6001 L50.1998,4.4001 C50.1998,3.2001 49.4998,2.3001 48.2998,2.3001 Z",
    id: "Fill-19",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5996,3.1 L51.5996,2.4 L51.2006,2.4 L51.2006,6.4 L51.5996,6.4 L51.5996,3.5 C51.7996,3.2 52.2996,2.8 52.7006,2.8 L52.9006,2.8 L52.9006,2.3 C52.4006,2.3 51.9006,2.6 51.5996,3.1",
    id: "Fill-20",
    mask: "url(#mask-4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logo-vertical.d2150d66.svg";
export { ForwardRef as ReactComponent };